export default __webpack_public_path__ + "static/media/hht2_ep03_timeline_q03_b.97a78915.png";